export class PaymentMode {


	constructor(id: number, name: string, imageUrl: string) {
		this.id = id;
		this.name = name;
		this.imageUrl = imageUrl;
	}

	id: number;
	name: string;
	imageUrl: string;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/PaymentMode.ts